<template>

  <div class="login">
    <div class="login-center">
      <div class="login-center-left" v-if="!codeImg">
         <el-tabs v-model="activeName">
     <!-- 账号登陆 -->
      <el-tab-pane label="账号登陆" name="account">
      <el-form ref="accountForm" :model="accountForm"  class="loginForm" :rules="loginRules">
         <el-form-item >
             <el-input placeholder="请输入账号" v-model="accountForm.username" style="width:100%;margin-left:10px;"> </el-input>
         </el-form-item>
          <el-form-item >
             <el-input placeholder="请输入密码" style="width:100%;margin-left:10px;" type="password" v-model="accountForm.password"> </el-input>
         </el-form-item>
          <!-- <Verify
          @success="capctchaCheckSuccess"
          :mode="'pop'"
          :captchaType="'blockPuzzle'"
          :imgSize="{ width: '330px', height: '155px' }"
          ref="verify"
        ></Verify> -->
          <!-- <el-form-item prop="code" v-if="captchaOnOff" label="验证码：" class="codeStyele">
        <el-input
          v-model="accountForm.code"
          auto-complete="off"
          placeholder="请输入验证码"
          style="width: 55%"
          @keyup.enter.native="handleLogin"
          
        >
          <svg-icon slot="prefix" icon-class="validCode" class="el-input__icon input-icon" />
        </el-input>
        <div class="login-code">
          <img :src="codeUrl" @click="getCode" class="login-code-img"/>
        </div>
      </el-form-item> -->
      <el-form-item style="margin:-20px 0 0 0px;">
          <el-checkbox  style="margin-left:10px;" v-model="accountForm.rememberMe" >记住密码</el-checkbox>
          <p class="register">立即注册</p>
        </el-form-item>
      </el-form>
        <!-- <div class="login-btn">
            <el-button
          :loading="loading"
          size="medium"
          type="primary"
          style="width:80%;"
          @click.native.prevent="handleLogin"
        >
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
       </div> -->
    </el-tab-pane>
    <!-- 短信登陆 -->
    <el-tab-pane label="短信登陆" name="shortMessage">
        <el-form ref="shortForm" :model="shortForm" label-width="80px" class="shortForm loginForm"> 
          <el-form-item label="手机号：">
             <el-input placeholder="请输入手机号" v-model="accountForm.phone"> <i slot="prefix" class="el-icon-mobile-phone"  /></el-input>
         </el-form-item>
         <el-form-item label="验证码：">
             <el-input  placeholder="请输入验证码" v-model="accountForm.phone"> <i slot="prefix" class="el-icon-message"  style="margin-top:10px;"/>   <template slot="append" style="width:20%;cursor:pointer;">获取验证码</template></el-input>
         </el-form-item>
        </el-form>
        
    </el-tab-pane>
  </el-tabs>
           <div class="login-btn">
             <el-button
             :loading="loading"
             size="medium"
             type="primary"
             style="width:80%;"
             @click.native.prevent="handleLogin"
             >
          <span v-if="!loading">登 录</span>
          <span v-else>登 录 中...</span>
        </el-button>
       </div>
       <div class="login-sanf">
        <div class="login-weixin" @click="wxCodeImg">
          <img src="../assets/login/weixin.png" alt="">
          <p>微信登录</p>
        </div>
        <div class="login-Alipay">
          <img src="../assets/login/Alipay.png" alt="">
          <p>支付宝登录</p>
        </div>
       </div>
      </div>
   
      <div class="login-center-left login-center-left-img">
           <img style="width:80%;height:90%;" v-if="codeImg" :src="codeImg" alt="" @click="wxCodeImg">
      </div>
     <div class="login-center-right">
         <!-- <img style="margin-left:-50px;" v-if="!codeImg" :src="qrCode" alt="" @click="wxCodeImg"> -->
         <img v-if="codeImg" :src="computer" alt="" @click="sjCodeImg">
     </div>
    </div>

    <div class="el-login-footer">
      <span>Copyright © 2018-2021 ruoyi.vip All Rights Reserved.</span>
    </div>
  </div>
</template>

<script>

// import Cookies from "js-cookie";
import qrCode from '@/assets/images/qrCode.png'
import computer from '@/assets/images/computer.png'
import { setToken } from '@/api/token.js'
import { login } from '@/api/login'
// import Verify from "@/components/Verifition/Verify.vue"
// import Verify from "@/components/Verifition/Verify.vue"

export default {
  //  components: { Verify },
//     components:{
// Verify
//     },
    data() {
        return{
         codeImg:undefined,
         activeName:'account',
         qrCode:qrCode,
         computer:computer,
         accountForm: {
        username: "admin",
        password: "admin123",
        rememberMe: false,
        code: "",
      },
      loading:false,
      shortForm:{

      },
       loginRules: {
        username: [
          { required: true, trigger: "blur", message: "请输入您的账号" }
        ],
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" }
        ],
        code: [{ required: true, trigger: "change", message: "请输入验证码" }]
      },
        }
    },
    methods:{
       sjCodeImg(){
       this.codeImg = undefined
    },
      async wxCodeImg(){
       this.axios({
             url:'http://47.119.141.79/fdp-dev'+'/wechat/getCode?path='+'pages/artificial/index',
         methods:'get',
         responseType:"blob"
       }).then(res=>{
         const blob = new Blob([res.data],{type: "image/jpeg"})
          this.codeImg = window.URL.createObjectURL(blob)
          this.scene =res.headers.scene
          this.codeLogin()
       })
    },
      codeLogin(){
      var url = 'ws://47.119.141.79/fdp-dev/webSocket/'+this.scene
                this.socket = new WebSocket(url)
                // 监听socket连接
                this.socket.onopen = this.open
                // 监听socket错误信息
                this.socket.onerror = this.error
                // 监听socket消息
                this.socket.onmessage = this.getMessage
    },
        open: function () {
            console.log("socket连接成功")
        },
        error: function () {
            console.log("连接错误")
        },
        getMessage: function (msg) {
            console.log(msg.data)
            if(msg.data!=='连接成功'){
              setToken(msg.data)
              this.$router.push({ path: this.redirect || "/" }).catch(()=>{});
            }
        },
        // send: function () {
        //     this.socket.send()
        // },
        close: function () {
            console.log("socket已经关闭")
        },
    handleLogin(){
        login(this.accountForm).then(res=>{
          if(res.code===200){
               setToken(res.token)
               this.$router.push('/index')
          }
        })
      // console.log(1);
    // this.$refs.accountForm.validate(valid => {
    //     if (valid) { 
    //       // this.$refs.verify.show();
    //    }
    // })
    }
    }
}
    
</script>

<style lang="scss" rel="stylesheet/scss">
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: url("../assets/images/login-background.jpg");
  background-size: cover;
}
.register{
  position: absolute;
  right: 0px;
  margin-top: -40px;
  color: #606266;
  cursor: pointer;
  
}
.title {
  margin: 0px auto 30px auto;
  text-align: center;
  color: #707070;
}
.login-center-left-img{
  display: flex;
  justify-content: center;
  align-items: center;
}
.login-center{
  display: flex;
  border-radius: 10px;
   width: 400px;
  //  height:350px ;
   background: #fff;
   opacity:0.8;
   .el-tabs__nav{
     text-align: center;
   }
  .el-tabs__item{
    width: 200px !important;
  }
  .loginForm{
    padding: 10px 50px 0 20px;
    .login-code{
   
     margin: -35px 0 0 145px;
 
    }
    
  }
  .login-center-left{
    width: 400px;
  }
  .login-center-right{
    width: 70px;
    height: 100%;
    display: flex;
    justify-content: center;
    
    img{
      margin-top: 5px;
      width: 35px;
      height: 35px;
    }
    // background:blue ;
  }
}
    .login-btn{
       width: 100%;
       display: flex;
       justify-content: center;
       align-items: center;
       margin: auto;
       padding-bottom: 30px;
     }
     .el-input-group__append{
       padding: 0 10px !important;
     }
     .el-input-group__append{
       cursor: pointer;
     }
.el-login-footer {
  height: 40px;
  line-height: 40px;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #fff;
  font-family: Arial;
  font-size: 12px;
  letter-spacing: 1px;
  margin: auto;
}
.login-code-img {
  height: 34px;
   border-radius: 2px;
}
.login-sanf{
  display: flex;
  margin-top: -10px;
  padding-bottom: 15px;
  .login-weixin{
    cursor: pointer;
  display: flex;
  img{
    width: 30px;
    height: 30px;
    margin-left: 30px;
  }
  p{
    color: #606266;
    margin: 5px 0 0 5px;
  }
}
.login-Alipay{
  cursor: pointer;
  display: flex;
  img{
    width: 30px;
    height: 30px;
    margin-left: 30px;
  }
  p{
    color: #606266;
    margin: 5px 0 0 5px;
  }
}
}

</style>